import React from 'react';
import './ServiceSingle.css';

import { PageTitle, SidebarHeading, Faqs } from '../../../components';
import { services } from '../../../constants';

import { FaDroplet } from 'react-icons/fa6';
import { FaCheck } from 'react-icons/fa';

import { Link, useLocation } from 'react-router-dom';



const ServiceSingle = () => {

  const location = useLocation();
  const serviceSingle = location.state;

  const features = serviceSingle.features;
  const process = serviceSingle.process;

  return (
    <>
      {/* Page Title */}
      <PageTitle title={serviceSingle.title} page={"Service Single"} />

      <section className='service-single page-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all services'} />

            <div className='box-container'>
              {services.map(service => {
                return  (
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Services/' + service.title,
                  }}
                  location = {{service}}
                  state= {service}
                  key={service.id}
                  className='item'><span><div className='icon'><FaDroplet /></div>{service.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

        <div className='service-info page-info'>

          {/* Service Image */}
          <div className='image'>
            <img src={serviceSingle.image} alt={serviceSingle.title} />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{serviceSingle.title}</h3>

            {/* Service Content */}
            {serviceSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Service Features Section */}
          <div className='sub-section'>

            <div className='box-container'>

              <div className='box-content sub-image'>
                <img src={serviceSingle.gallery[0]} alt="Service Features" />
              </div>

              <div className='box-content'>
                <h3 className='sub-heading'>Service Features</h3>
                <p>Key highlights of our {serviceSingle.title} service, ensuring pure water and timely delivery.</p>

                {/* List of Service Features */}
                <ul>
                  {features.map((feature, index) => {
                    return <li key={index}>
                      <div className='icon'><FaCheck /></div>
                      {feature}
                    </li>
                  })}
                </ul>
              </div>

            </div>

          </div>

          {/* Service Process Section */}
          <div className='sub-section'>

            <div className='box-container'>

              <div className='box-content'>
                <h3 className='sub-heading'>Service Process</h3>
                <p>Key steps of our {serviceSingle.title} service, ensuring safe handling and reliable delivery.</p>

                {/* List of Service Process */}
                <ul>
                  {process.map((step, index) => {
                    return <li key={index}>
                      <div className='icon'><FaDroplet /></div>
                      {step}
                    </li>
                  })}
                </ul>
              </div>

              <div className='box-content sub-image'>
                <img src={serviceSingle.gallery[1]} alt="Service Process" />
              </div>

            </div>

          </div>

          {/* Section for frequently asked questions */}
          <div className='service-faqs sub-section'>

            <h3 className='sub-heading'>frequently asked questions</h3>

            {/* Faq Accordion container */}
            <Faqs faqs={serviceSingle.faqs} />

          </div>
        
        </div> 

      </section> 
    </> 
  );
}

export default ServiceSingle;